import React from 'react';
import ReactDOM from 'react-dom/client';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import './i18n/i18n';
import App from './App';
import { initAdapters, fetchAdapterConfig, validateProductLineConfig } from './adapters';
import { initShellEffects } from './shell/events/shellEffects';
import { initWorkspaceRemotes } from './features/Workspaces/loadRemote';

export async function runBootstrap(): Promise<void> {
  const adapterConfig = await fetchAdapterConfig();
  validateProductLineConfig(adapterConfig);
  initAdapters(adapterConfig);
  initShellEffects();
  initWorkspaceRemotes();

  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

export function renderBootstrapError(err: unknown): void {
  console.error('[bootstrap] Fatal error during initialisation:', err);
  document.body.innerHTML = `<pre style="padding:2rem;color:red">Boot failed: ${String(err)}</pre>`;
}
